<template>
  <div>

    <div class="remark-header">绿贝小助手8.3</div>

    <div>{{ testText }}</div>
    <div id="text" v-if="remark" class="remark-container">
      <p v-html="highlightedB"></p>
    </div>


    <div v-if="QrodeUrl || chezhengUrl || jiaoqiangUrl || shangyeUrl" class="image-wrapper">
      <img v-if="chezhengUrl" :src="chezhengUrl" alt="车证" class="auto-fit-image" @error="chezhengUrl = ''">
      <img v-if="jiaoqiangUrl" :src="jiaoqiangUrl" alt="交强险" class="auto-fit-image" @error="jiaoqiangUrl = ''">
      <img v-if="shangyeUrl" :src="shangyeUrl" alt="商业险" class="auto-fit-image" @error="shangyeUrl = ''">
      <img v-if="QrodeUrl" :src="QrodeUrl" alt="交款码" class="auto-fit-image" @error="QrodeUrl = ''">
      <a v-if="QrodeUrllink" :href="QrodeUrllink" target="_blank"
        rel="noopener noreferrer" style="display: block; margin-top: 8px; color: #1890ff; text-decoration: underline;">
        打开二维码
      </a>
    </div>

    <div v-if="button1data">
      <pre class="remark-container">{{ button1data }}</pre>
    </div>

    <p v-if="loading">尝试获取数据中...</p>

    <!-- 统一错误提示（已合并重复） -->
    <p v-if="error" class="error-text">{{ error }}</p>

    <div class="button-group">
      <button ref="jiaoguanButton" :disabled="loading" @click="fetchData(carNo)">交管</button>
      <button ref="hetongButton" :disabled="loading" @click="fetchHTData(carNo)">备案查询</button>
      <button ref="qunButton" :disabled="loading" @click="createGroupChat()">建退车群</button>
      <button ref="zhangdanButton" :disabled="loading" @click="fetchZDData(carNo)">账单</button>
      <button ref="dingweiButton" :disabled="loading" @click="fetchDWData(carNo)">定位</button>
      <button ref="mileButton" :disabled="loading" @click="fetchMileData(carNo)">里程</button>
      <button ref="czGPSButton" :disabled="loading" @click="fetchCZGPSData(carNo)">车证GPS</button>
      <button ref="qRButton" :disabled="loading" @click="fetchQrcode(orderid)">交款码</button>
      <button ref="qRRButton" :disabled="loading" @click="refetchQrcode(carNo)">刷新</button>
      <button ref="yimatongqRButton" :disabled="loading" @click="fetchyimatongQrcode(orderid)">一码通</button>
      <button ref="noweizhangButton" :disabled="loading" @click="fetchNoweizhangData(orderid)">查询奖励</button>
      <button ref="baodanButton" :disabled="loading" @click="fetchWarrantyStatus(carNo)">车证保单</button>
    </div>

    <!-- 无数据提示（修复 ref 解包错误） -->
    <div v-if="recordsList.length === 0 && !loading && hasQueriedReward">
      暂无奖励信息，请联系财务核对。
    </div>

    <!-- 记录列表 -->
    <div v-for="record in recordsList" :key="record.id" class="record-item">
      <p>
        {{ record.billName }} - {{ record.status }} - {{ record.operatorStatus }}<br />
        {{ record.billStart }}~{{ record.billEnd }}：{{ record.value }}
      </p>
      <span v-if="record.remark">备注：{{ record.remark }}</span>
      <button @click="openDialog(record.id, record.remark || '')" :disabled="updating">
        编辑备注
      </button>
      <hr />
    </div>

    <!-- 对话框（简易版，可用 Element Plus / Naive UI 等替换） -->
    <div v-if="dialogVisible" class="dialog-overlay">
      <div class="dialog">
        <h3>填写备注</h3>
        <input v-model="remarkInput" type="text" placeholder="请输入备注"
          style="width: 100%; padding: 8px; margin: 10px 0;" />
        <div>
          <button @click="confirmUpdate" :disabled="updating">确定</button>
          <button @click="dialogVisible = false" :disabled="updating">取消</button>
        </div>
      </div>
    </div>

  </div>

</template>

<script setup>
import { onMounted, ref, computed } from 'vue';
import axios from 'axios';
import * as ww from '@wecom/jssdk'

// ========== API 基础配置（P1-1：axios 实例化） ==========
const xzsApi = axios.create({
  baseURL: 'https://xzs.lbzuche.cn',
  timeout: 15000,
});
const lifeApi = axios.create({
  baseURL: 'https://life.greenbaytrip.com:8080',
  timeout: 15000,
});

// 工具函数：延迟
const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

// 工具函数：向日志追加数据
const appendLog = (data) => {
  if (button1data.value) {
    button1data.value += '\n-----------------\n';
  }
  button1data.value += data;
};

// ========== 签名缓存（sessionStorage） ==========
// 企业微信 JSAPI 签名有效期为 2 小时，这里用 30 分钟 TTL 保守取值。
// 缓存后即使页面刷新、HMR、或其他原因再次进入 initializeWW()，也不会重复请求 /signnew/。
const SIGN_CACHE_KEY = 'wecom_sign_cache_v1';
const SIGN_CACHE_TTL_SEC = 30 * 60; // 30 分钟

const getCachedSign = () => {
  try {
    const raw = sessionStorage.getItem(SIGN_CACHE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    const signTs = parseInt(parsed?.data?.timestamp, 10);
    if (!signTs || !parsed.data) return null;
    const ageSec = Math.floor(Date.now() / 1000) - signTs;
    if (ageSec >= SIGN_CACHE_TTL_SEC) {
      sessionStorage.removeItem(SIGN_CACHE_KEY);
      return null;
    }
    return parsed.data;
  } catch {
    return null;
  }
};

const setCachedSign = (data) => {
  try {
    sessionStorage.setItem(
      SIGN_CACHE_KEY,
      JSON.stringify({ data, cachedAt: Math.floor(Date.now() / 1000) })
    );
  } catch {
    // sessionStorage 不可用时静默忽略
  }
};

// ========== 状态变量 ==========
const remark = ref('')
const orderid = ref('')
const carNo = ref('')
const singdata = ref('')
const userid = ref('')
const loading = ref(true);
const error = ref(null);
const testText = ref('')
const button1data = ref('');
const QrodeUrl = ref('');
const QrodeUrllink = ref('');
const chezhengUrl = ref('');
const jiaoqiangUrl = ref('');
const shangyeUrl = ref('');
const comUsername = ref('')
const code = ref('')
const hasQueriedReward = ref(false);

let isInitialized = false;
let initializationPromise = null;
let signRequestPromise = null;

const jiaoguanButton = ref(null);
const hetongButton = ref(null);
const noweizhangButton = ref(null);
const czGPSButton = ref(null);
const dingweiButton = ref(null);
const mileButton = ref(null);
const qRButton = ref(null);
const qRRButton = ref(null);
const yimatongqRButton = ref(null);
const zhangdanButton = ref(null);
const qunButton = ref(null);
const baodanButton = ref(null);

const recordsList = ref([]);
const dialogVisible = ref(false);
const currentRecordId = ref(null);
const remarkInput = ref('');
const updating = ref(false);

// ========== 对话框相关 ==========
const openDialog = (id, remarkText) => {
  currentRecordId.value = id;
  remarkInput.value = remarkText;
  dialogVisible.value = true;
};

const confirmUpdate = async () => {
  if (updating.value) return;

  updating.value = true;
  try {
    const payload = {
      id: currentRecordId.value,
      remark: remarkInput.value.trim(),
      operator: comUsername.value,
    };

    await lifeApi.put('/api/reduction', payload, {
      headers: { 'Content-Type': 'application/json' }
    });

    const index = recordsList.value.findIndex(r => r.id === currentRecordId.value);
    if (index !== -1) {
      recordsList.value[index].remark = remarkInput.value.trim();
    }

    dialogVisible.value = false;
    alert('备注更新成功！');
  } catch (err) {
    alert('更新失败: ' + (err.response?.data?.message || err.message));
  } finally {
    updating.value = false;
  }
};

// ========== 通用请求函数 ==========
const request = async ({ api, url, params = {}, buttonRef = null, append = true, onSuccess = null }) => {
  loading.value = true;
  error.value = null;
  const instance = api === 'life' ? lifeApi : xzsApi;

  if (buttonRef?.value) {
    buttonRef.value.disabled = true;
  }

  try {
    const response = await instance.get(url, { params });
    if (onSuccess) {
      onSuccess(response.data);
    } else if (append) {
      appendLog(response.data);
    }
    return response.data;
  } catch (err) {
    error.value = `请求失败: ${err.message}`;
    throw err;
  } finally {
    loading.value = false;
    if (buttonRef?.value) {
      buttonRef.value.disabled = false;
    }
  }
};

// ========== 业务函数 ==========
const fetchData = () => request({ url: `/122/${carNo.value}`, params: { comUsername: comUsername.value }, buttonRef: jiaoguanButton });
const fetchHTData = () => request({ url: `/sohetong/${carNo.value}`, params: { comUsername: comUsername.value }, buttonRef: hetongButton });
const fetchDWData = () => request({ url: `/carapilocation/${carNo.value}`, params: { comUsername: comUsername.value }, buttonRef: dingweiButton });
const fetchMileData = () => request({ url: `/carapimile/${carNo.value}`, params: { comUsername: comUsername.value }, buttonRef: mileButton });
const fetchCZGPSData = () => request({ url: `/carczgps/${carNo.value}`, params: { comUsername: comUsername.value }, buttonRef: czGPSButton });
const fetchZDData = () => request({
  url: `/carapizhangdan/${carNo.value}`,
  params: { comUsername: comUsername.value, orderid: orderid.value },
  buttonRef: zhangdanButton
});

const fetchQrcode = () => request({
  api: 'xzs',
  url: `/qrcode/${orderid.value}`,
  params: { comUsername: comUsername.value },
  buttonRef: qRButton,
  append: false,
  onSuccess: (data) => { QrodeUrl.value = data; }
});

const fetchyimatongQrcode = () => request({
  api: 'life',
  url: `/api/order/generate2`,
  params: { orderId: orderid.value },
  buttonRef: yimatongqRButton,
  append: false,
  onSuccess: (data) => {
    QrodeUrl.value = data?.data?.QrcodeUrl;
    QrodeUrllink.value = data?.data?.url;
  }
});

const refetchQrcode = () => request({
  api: 'xzs',
  url: `/reqrcode/${carNo.value}`,
  params: { comUsername: comUsername.value },
  buttonRef: qRRButton,
  append: false,
  onSuccess: (data) => { QrodeUrl.value = data; }
});

const fetchNoweizhangData = async () => {
  loading.value = true;
  error.value = null;
  if (noweizhangButton.value) noweizhangButton.value.disabled = true;
  try {
    const response = await lifeApi.get('/api/reduction', {
      params: { page: 1, size: 100, orderId: orderid.value }
    });
    recordsList.value = response.data?.data?.records || [];
    hasQueriedReward.value = true;
  } catch (err) {
    error.value = `请求失败: ${err.message}`;
    recordsList.value = [];
  } finally {
    loading.value = false;
    if (noweizhangButton.value) noweizhangButton.value.disabled = false;
  }
};

// ========== 企业微信 SDK ==========
const getConfigSignature = async () => {
  if (!singdata.value) return null;
  return {
    timestamp: singdata.value['timestamp'],
    nonceStr: singdata.value['nonceStr'],
    signature: singdata.value['signatureCom'],
  }
}

const getAgentConfigSignature = async () => {
  if (!singdata.value) return null;
  return {
    timestamp: singdata.value['timestamp'],
    nonceStr: singdata.value['nonceStr'],
    signature: singdata.value['signatureAG'],
  }
}

const registerWW = () => {
  ww.register({
    corpId: 'ww2fcd8b58ddfada9e',
    agentId: '1000032',
    jsApiList: ['getCurExternalContact', 'openEnterpriseChat', 'sendChatMessage'],
    getConfigSignature,
    getAgentConfigSignature,
    debug: true
  });
};

const initializeWW = async () => {
  // 1. 内存中已有签名，直接跳过（包括已注册过 ww.register 的情况）
  if (singdata.value) {
    console.log('已有签名数据，跳过初始化');
    return;
  }

  // 2. sessionStorage 缓存中仍有有效签名，直接复用，不发请求
  const cached = getCachedSign();
  if (cached) {
    console.log('使用 sessionStorage 中缓存的签名数据（30 分钟内有效）');
    singdata.value = cached;
    registerWW();
    return;
  }

  // 3. 已有进行中的请求，复用其 Promise，避免并发
  if (signRequestPromise) {
    console.log('签名请求正在进行中，等待完成...');
    return signRequestPromise;
  }

  // 4. 真正发起请求
  signRequestPromise = (async () => {
    try {
      console.log('开始初始化企业微信SDK...');

      const response = await xzsApi.get('/signnew/');
      singdata.value = response.data;
      // 写入缓存，下次进入（包括页面刷新）可直接复用
      setCachedSign(response.data);

      registerWW();
      console.log('企业微信SDK注册完成');
    } catch (err) {
      console.error('初始化失败:', err);
      error.value = '初始化企业微信SDK失败: ' + err.message;
      throw err;
    } finally {
      signRequestPromise = null;
    }
  })();

  return signRequestPromise;
}

// ========== 创建退车群 ==========
const createGroupChat = async () => {
  loading.value = true;
  error.value = null;
  if (qunButton.value) qunButton.value.disabled = true;
  try {
    console.log('创建退车群...');
    const currentDate = new Date();
    const year = String(currentDate.getFullYear()).slice(-2);
    const month = String(currentDate.getMonth() + 1).padStart(2, '0');
    const result = "-" + year + "-" + month + '退车群';
    ww.openEnterpriseChat({
      groupName: carNo.value + result,
      userIds: [
        comUsername.value,
        'liujian2'
      ],
      externalUserIds: [
        userid.value
      ]
    })
    console.log('创建退车群完成');
  } catch (err) {
    console.error('创建退车群失败:', err);
    error.value = '创建退车群失败: ' + err.message;
    throw err;
  } finally {
    loading.value = false;
    if (qunButton.value) qunButton.value.disabled = false;
  }
};

// ========== 获取外部用户ID ==========
const getUserId = async () => {
  try {
    return new Promise((resolve, reject) => {
      ww.getCurExternalContact({
        success(result) {
          console.log('成功获取外部用户ID:', result['userId']);
          resolve(result['userId']);
        },
        fail(result) {
          console.error('获取用户ID失败:', result);
          reject(new Error('获取用户ID失败'));
        }
      });
    });
  } catch (err) {
    console.error('获取用户ID失败:', err);
    error.value = '获取用户ID失败: ' + err.message;
    throw err;
  }
}

// ========== 获取用户备注信息 ==========
const fetchUser = async () => {
  if (!userid.value) {
    console.log('未获取到用户ID，跳过获取备注信息');
    return;
  }
  loading.value = true;
  error.value = null;
  try {
    const url = `/userremark2/${userid.value}?comuserid=${encodeURIComponent(localStorage.getItem('comUsername'))}`;
    const response = await xzsApi.get(url);
    const res = response.data;

    remark.value = res['msg'];
    orderid.value = res['orderid'];
    carNo.value = res['carno'];
    console.log('成功获取用户备注信息:', response.data);
  } catch (err) {
    console.error('获取用户备注信息失败:', err);
    error.value = '获取用户备注信息失败: ' + err.message;
  } finally {
    loading.value = false;
  }
}

// ========== 应用初始化 ==========
function setIsInitializing(value) {
  sessionStorage.setItem('app_initializing', value.toString());
}

async function initApp() {
  if (isInitialized) {
    console.log('应用已初始化，跳过重复执行');
    return Promise.resolve();
  }

  if (initializationPromise) {
    console.log('初始化已在进行中，等待完成...');
    return initializationPromise;
  }

  console.log('开始初始化应用...');
  setIsInitializing(true);

  initializationPromise = (async () => {
    try {
      await initializeWW();

      let retryCount = 0;
      const maxRetries = 3;
      let userId = null;

      while (retryCount < maxRetries && !userId) {
        try {
          userId = await getUserId();
          console.log(`第 ${retryCount + 1} 次尝试获取用户ID成功:`, userId);
        } catch (err) {
          console.log(`第 ${retryCount + 1} 次获取用户ID失败:`, err.message);
          retryCount++;
          if (retryCount < maxRetries) {
            console.log('等待1秒后重试...');
            await delay(1000);
          }
        }
      }

      if (userId) {
        userid.value = userId;
        await fetchUser();
        comUsername.value = encodeURIComponent(localStorage.getItem('comUsername'))
        isInitialized = true;
        sessionStorage.setItem('app_initialized', 'true');
        console.log('初始化成功完成');
      } else {
        userid.value = '初始化-没有获取用户ID';
        console.log('达到最大重试次数仍未获取到用户ID');
        throw new Error('无法获取用户ID');
      }
    } catch (err) {
      console.error('初始化流程失败:', err);
      error.value = '初始化流程失败: ' + (typeof err === 'string' ? err : err.message);
      isInitialized = false;
      initializationPromise = null;
    } finally {
      loading.value = false;
    }
  })();

  return initializationPromise;
}

// ========== 生命周期 ==========
onMounted(async () => {
  const url = new URL(window.location.href)
  const authCode = localStorage.getItem('oauth_code')
  console.log('url:', url, 'authcode:', authCode)
  if (authCode) {
    code.value = authCode
    console.log('提取到 code:', code.value)
    await initApp()
    return
  } else {
    console.log('干净页面，初始化应用')
    return
  }
});

// ========== 保单车证相关 ==========
// 后端 /pdfToImage 接口已支持 user 参数（async def pdf_to_image(carNo, type, user='')）
// 该参数会告诉后端是谁在查询保单，便于审计/统计
// 图片加载失败时通过模板中的 @error 直接清空对应 URL，避免显示 404 图标
const fetchWarrantyStatus = async (carno) => {
  if (!carno) {
    error.value = '车牌号为空';
    return;
  }

  loading.value = true;
  try {
    const encodedCarNo = encodeURIComponent(carno);
    // 优先使用 comUsername（登录用户名），否则用 userid（外部用户ID）
    const currentUser = comUsername.value || userid.value || '';
    const encodedUser = encodeURIComponent(currentUser);

    // 车证图片（直接走 COS，不经过后端）
    chezhengUrl.value = `https://life-1328614890.cos.ap-chengdu.myqcloud.com/车证/${encodedCarNo}.jpg`

    // 交强险/商业险走后端 /pdfToImage 接口
    // URL 中带 user 参数让后端知道是谁在查询（后端可记录访问日志）
    jiaoqiangUrl.value = `https://xzs.lbzuche.cn/pdfToImage?carNo=${encodedCarNo}&type=jiaoqiang&user=${encodedUser}`
    shangyeUrl.value = `https://xzs.lbzuche.cn/pdfToImage?carNo=${encodedCarNo}&type=shangye&user=${encodedUser}`
  } catch (err) {
    error.value = '获取车证信息失败: ' + err.message;
  } finally {
    loading.value = false;
  }
};

// ========== 高亮到期日期 ==========
const DATE_REGEX = /(到期[：:]\s*(\d{4})-(\d{1,2})-(\d{1,2})(?:\s+\d{1,2}:\d{1,2}:\d{1,2})?|车辆年审[：:]\s*(\d{4})-(\d{1,2})-(\d{1,2})|车证年检到期[：:]\s*(\d{4})(\d{1,2})(\d{1,2}))/g;

const highlightedB = computed(() => {
  if (!remark.value) return remark.value;

  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const oneMonthLater = new Date(today);
  oneMonthLater.setMonth(oneMonthLater.getMonth() + 1);

  return remark.value.replace(DATE_REGEX, (match, ...args) => {
    let y, m, d;
    if (args[1]) {
      y = +args[1]; m = +args[2]; d = +args[3];
    } else if (args[4]) {
      y = +args[4]; m = +args[5]; d = +args[6];
    } else if (args[7]) {
      y = +args[7]; m = +args[8]; d = +args[9];
    } else {
      return match;
    }

    const target = new Date(y, m - 1, d);
    if (target < today) {
      return `<span class="highlight highlight-expired">${match}</span>`;
    } else if (target <= oneMonthLater) {
      return `<span class="highlight">${match}</span>`;
    }
    return match;
  });
});
</script>

<style>
/* 容器样式 */
.remark-container {
  background-color: #f9f9f9;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 16px;
  max-width: 600px;
  margin: 20px auto;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  white-space: pre-wrap;
  font-size: 16px;
}

.highlight {
  color: red;
}

.highlight-expired {
  color: red;
  font-weight: bold;
}

/* 错误文本样式（合并后统一显示） */
.error-text {
  color: red;
  background-color: #fff5f5;
  border: 1px solid #ffccc7;
  border-radius: 4px;
  padding: 8px 12px;
  margin: 8px 0;
}

/* 标题样式 */
.remark-header {
  font-size: 18px;
  font-weight: bold;
  color: #333;
  margin-bottom: 8px;
}

.no-wrap {
  white-space: nowrap;
}

.image-wrapper {
  width: 100%;
  padding: 20px 0;
  text-align: center;
}

.auto-fit-image {
  width: 70%;
  height: auto;
  max-width: 100%;
  display: inline-block;
  border-radius: 8px;
}

/* 按钮组样式 */
.button-group {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  margin: 10px 0;
}

button {
  cursor: pointer;
  background-color: #007bff;
  color: white;
  border: none;
  padding: 6px 12px;
  font-size: 14px;
  height: 28px;
  min-width: 50px;
  border-radius: 4px;
}

button:hover:not(:disabled) {
  background-color: #0056b3;
}

button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.record-item {
  margin: 10px 0;
  padding: 10px;
  border: 1px solid #eee;
  border-radius: 4px;
}

.dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.dialog {
  background: white;
  padding: 20px;
  border-radius: 8px;
  width: 300px;
}
</style>